var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pageTitle"},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"inner"},[_c('h2',{staticClass:"title"},[_c('span',{staticClass:"primary"},[_vm._v(_vm._s(_vm.largeTitle))]),_c('span',{staticClass:"secondary"},[_vm._v(_vm._s(_vm.smallTitle))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }